export default "__VITE_ASSET__BCyoQ0J$__"